import React from "react";
import "./PageLayout.css";
import MenuComponent from "./pages/MenuComponent";

const PageLayout = ({ title, children }) => {
  return (
    <div className="page-container">
      <MenuComponent />
      <div className="page-inner">
        {title && <h1 className="page-title">{title}</h1>}
        <div className="page-content">{children}</div>
      </div>
    </div>
  );
};

export default PageLayout;
